export const ContactUsActionTypes = {
    LOGOUT: 'LOGOUT',

    CONTACT_US_SEND_MESSAGE_REQUEST: 'CONTACT_US_SEND_MESSAGE_REQUEST',
    CONTACT_US_SEND_MESSAGE_REQUEST_SUCCESS: 'CONTACT_US_SEND_MESSAGE_REQUEST_SUCCESS',
    CONTACT_US_SEND_MESSAGE_REQUEST_ERROR: 'CONTACT_US_SEND_MESSAGE_REQUEST_ERROR',
    CONTACT_US_SEND_MESSAGE_REQUEST_STATUS: 'CONTACT_US_SEND_MESSAGE_REQUEST_STATUS',

    CONTACT_US_MESSAGE_LIST_REQUEST: 'CONTACT_US_MESSAGE_LIST_REQUEST',
    CONTACT_US_MESSAGE_LIST_REQUEST_SUCCESS: 'CONTACT_US_MESSAGE_LIST_REQUEST_SUCCESS',
    CONTACT_US_MESSAGE_LIST_REQUEST_ERROR: 'CONTACT_US_MESSAGE_LIST_REQUEST_ERROR'
}
